import { ContentWithAside } from "layouts/kiosk-h"

import { themeOptionFactories } from "./theme"

import { EmTouristKioskHPage } from "./pages/em-tourist/index.kiosk"

import { EmTouristMobilePage } from "./pages/em-tourist"

export const emTourist = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        path: "tourist",
        element: <EmTouristMobilePage />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [
      {
        path: "tourist",
        element: <EmTouristKioskHPage Layout={ContentWithAside} />,
      },
    ],
  },
}
